import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import Radio from "@faire/web--source/slate/Radio";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IProps {
  title?: string;
  value?: string;
  label?: string;
  ariaLabel?: string;
  onClick?: () => void;
  active?: boolean;
}

export const RadioMFAOption: React.FC<IProps> = ({
  onClick,
  title,
  value,
  label,
  active,
  ariaLabel,
}) => (
  <StyledRadio
    label={label ?? title}
    align="flex-start"
    aria-label={ariaLabel ?? title}
    onClick={onClick}
    active={active}
  >
    <RadioLabelColumn>
      <Typography>{title}</Typography>
      <RadioValueTypography color={Core.text.subdued}>
        {value}
      </RadioValueTypography>
    </RadioLabelColumn>
  </StyledRadio>
);

const RadioValueTypography = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RadioLabelColumn = styled(Column)`
  padding: ${getSpacing(0, "1x")};
  width: calc(100% - 10px);
`;

const StyledRadio = styled(Radio)`
  /* This is required for truncating the
  radio value on various screen widths as
  truncating requires a determinate width */
  width: 100%;
  label {
    width: 100%;
  }
`;
